export const VIEW_LIMIT = 3;
export const SESSION_STORAGE_KEY = 'tradePromo';

export const TRADE_WELCOME_PROMO_CODE = 'TRADEWELCOME';
export const TRADE_SHIP_PROMO_CODE = 'SHIP2019';
export const RISK_FREE_PROMO_CODE = 'RISKFREE';
export const BRONZE_LOANER_PROGRAM = 'BRONZE_LOANER_PROGRAM';
export const TRADE_PROMO_CODES = [TRADE_SHIP_PROMO_CODE, RISK_FREE_PROMO_CODE];
export const EXPIRING_TRADE_PROMO_CODES = [
    TRADE_WELCOME_PROMO_CODE,
    TRADE_SHIP_PROMO_CODE,
    RISK_FREE_PROMO_CODE,
];

export const MODAL_IDS = {
    [TRADE_SHIP_PROMO_CODE]: 'inactiveFirmPromoModalViews',
    [RISK_FREE_PROMO_CODE]: 'inactiveFirmPromoModalViews',
    [BRONZE_LOANER_PROGRAM]: 'tradePromoEndOfYearModal',
};
export const EXPIRING_MODAL_IDS = {
    [TRADE_WELCOME_PROMO_CODE]: 'tradeWelcomeExpiringPromo',
    [TRADE_SHIP_PROMO_CODE]: 'inactiveFirmExpiringPromoModalViews',
    [RISK_FREE_PROMO_CODE]: 'inactiveFirmExpiringPromoModalViews',
};
